import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {IEvent} from './getEventApi'

interface IProps {
    className?: string
}

export const getEventDetail = async (id: string): Promise<ApiRes<IEvent>> => {
    return await apiGet(API_URL, `admin/event/${id}`)
}
